import { __makeTemplateObject } from 'tslib';
import { css } from 'styled-components';
import { baseStyles } from '../BaseLink/BaseLink.baseStyles.js';
import { buildSpacingCSS } from '../../theme/utils/spacing.js';

var RouterLinkStyles = function RouterLinkStyles(theme, globalMargins, propMargins) {
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n"])), buildSpacingCSS(globalMargins), buildSpacingCSS(propMargins, true), baseStyles(theme));
};
var templateObject_1;

export { RouterLinkStyles };
//# sourceMappingURL=RouterLink.baseStyles.js.map
